export { default } from './StatisticsWidget';
